import React,{useEffect, useState} from 'react';
import '../App.css';
import '../assets/customStyles/custom.css';
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Box as GBox } from 'grommet';
import 'typeface-roboto';
import skillsData from '../data/skills.json'
import frontEndIcon from '../assets/images/frontEndIcon.png'

const Skills = () => {
  const [value, setValue] = React.useState(0);
  let [skills, setSkills] = useState([])
  let [loading, setLoading] = useState(true)

  useEffect(() => {
    let skills = JSON.parse(JSON.stringify(skillsData))
    console.log(skills)
    setSkills(skills)
    setLoading(false)
  }, [])

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    !loading && 
     <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', width: '100%',maxWidth:800, padding: 0, paddingTop: 50, paddingBottom: 50 }}>
      <GBox style={{ color: '#fff', width: '100%', display: 'flex' }}>


        <GBox style={{ justifyContent: 'space-evenly', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          <GBox id="front-end" animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 15 }} >

            <GBox elevation='xlarge' direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "rgb(1 0 41)", maxWidth: 300, height: 280, }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h4 style={{ marginTop: 10, marginBottom: 2, fontSize:22 }}>{skills[0].title}</h4>
              
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
                {skills[0].languages.map(l=><Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label={l} />)}
              </div>

              <p style={{ textAlign: "left", margin: 2, fontSize: 16 }}>{skills[0].description}</p>

            </GBox>
          </GBox>

          <GBox id="back-end" animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 15 }} >

            <GBox elevation='xlarge' direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "rgb(1 0 41)", maxWidth: 300, height: 280 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h4 style={{ marginTop: 10, marginBottom: 2,fontSize:22  }}>{skills[1].title}</h4>
                
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
              {skills[1].languages.map(l=><Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label={l} />)}
              </div>

              <p style={{ margin: 0, textAlign: "left", paddingLeft: 5, paddingRight: 5, fontSize: 16, }}>{skills[1].description}</p>
           
            </GBox>

          </GBox>
        </GBox>
        <GBox id="database" style={{ justifyContent: 'space-evenly', display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
          <GBox animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 15 }} >

            <GBox  direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "rgb(1 0 41)", height: 280, maxWidth: 300,  }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h4 style={{ marginTop: 10, marginBottom: 2,fontSize:22  }}>{skills[2].title}</h4>
            
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
              {skills[2].languages.map(l=><Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label={l} />)}
              </div>
              <p style={{ textAlign: "left", margin: 2, padding: 0, fontSize: 16 }}>{skills[2].description}</p>
         
            </GBox>
          </GBox>

          <GBox id="tools" animation="zoomIn" direction="column" style={{ alignItems: "center", marginTop: 15 }} >

            <GBox direction="column" style={{ margin: 0, padding: 10, paddingBottom: 10, background: "rgb(1 0 41)", height: 280, maxWidth: 300 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <h4 style={{ marginTop: 10, marginBottom: 2, fontSize:22  }}>{skills[3].title}</h4>
              
              </div>
              <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', marginBottom: 5, }}>
              {skills[3].languages.map(l=><Chip style={{ marginTop: 5, marginRight: 5 }} color='secondary' label={l} />)}
              </div>
              <p style={{ textAlign: "left", margin: 2, padding: 0, fontSize: 16 }}>{skills[3].description}</p>

            </GBox>
          </GBox>
        </GBox>
      </GBox>

  
    </div>


  )
}

export default Skills;